<template>
	<div class="choice_block sluzebka m-3 p-3">
		<div class="intro">
			<h1 class="pb-4">Інструкції з написання </h1>
			<b-form @submit="onSubmit"  @submit.stop.prevent >
				<err></err>

				<div class="steps">
					<div class="step">
						<b-form-group label="1. Виберiть з випадаючого списку організацію">
							<div class="select_step width-mobile-auto">
								<b-form-select
									value-field="id"
									text-field="small_title"
									v-model="form.tov_id" :options="tov_list" required>

								</b-form-select>
							</div>
						</b-form-group>

						<b-form-group label="2. Виберiть з випадаючого списку службу">
							<div class="select_step width-mobile-auto">
								<b-form-select
									value-field="id"
									text-field="title"
									:disabled="is_locked_select('service')"
									v-model="form.service_id"
									:options="service_list" required>
								</b-form-select>
							</div>
						</b-form-group>

						<b-form-group label="3. Виберiть з випадаючого списку - питання, щодо якого ініціюється/створюється">
							<div class="select_step width-mobile-auto">
								<b-form-select
									value-field="template_id"
									text-field="question_title"
									:disabled="is_lock_question"
									v-model="form.question_id"
									:state="validation_question"
									:options="question_list" required></b-form-select>
							</div>
						</b-form-group>

						<b-form-group label="4. Адресат" class="min_heigh_rec">
							<div class="select_step empty_recipient width-mobile-auto" >
								<transition name="slide-fade" mode="out-in">
									<user_block
										class="shadow-1 border"
										key="user_block"
										v-if="form.recipient_id > 0"
										v-bind:user_id=parseInt(this.recipient.user_id)>
									</user_block>

									<b-form-invalid-feedback :state="!validation_form" v-else key="form_er">
										Адресат підставляеться автоматично.Оберіть організацію, службу, та питання
									</b-form-invalid-feedback>
								</transition>
							</div>
						</b-form-group>

					</div>
					<button class="btn btn-lg btn-outline-primary waves-effect waves-themed" :disabled=validation_form  type="submit">
						<span class="fal" :class="{'fa-check mr-1' : !validation_form, 'fa-exclamation-triangle' : validation_form}"></span>
						Продовжити
					</button>
				</div>
			</b-form>
		</div>
	</div>
</template>

<script>

import {mapGetters} from "vuex";
import err from "../err_create/err.vue";
import user_block from "../../../../shared/user/user_block/user_block.vue";

export default {
	name: "mem_quest",
	components : {
		err,
		user_block
	},
	data() {
		return {
			is_lock_question : false,
			is_lock_service : false,
		}
	},
	created() {
		this.getOrganizationItems();
		this.getServicesItems();
	},


	methods : {

		is_locked_select(type) {
			switch (type) {
				case 'question' : {
					if (this.question_list.length === 1) {
						return true;
					}
				}

				case 'service' : {
					if (this.service_list.length === 1) {
						return true;
					}
				}
			}
		},

		async getOrganizationItems () {
			await api.get('memorandum/organizations').then(({data}) => {
				if (data.status === "operation_success") {
					this.$store.dispatch('memorandum_create/SET_CREATE_MEM_FIELDS',{
						'tov_list' : data.data,
					});

					if(this.def_tov_id > 0) {
						this.form.tov_id = this.def_tov_id;
					}
				}
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
			});
		},

		async getServicesItems () {

			this.$store.dispatch('memorandum_create/SET_CREATE_MEM_FIELDS',{
				'service_list' : [],
			});

			let url = 'memorandum/departments';
			if(this.mem_addon.length > 0) {
				url = 'memorandum/departments/' + this.mem_addon;
			}

			await api.get(url).then(({data}) => {
				if (data.status === "operation_success") {
					this.$store.dispatch('memorandum_create/SET_CREATE_MEM_FIELDS',{
						'service_list' : data.data,
					});

					if(this.def_service_id > 0 && this.service_list.length > 0) {
						this.form.service_id = this.def_service_id;
					}

					if (this.service_list.length > 0 && this.service_list.length === 1) {
						this.form.service_id = this.service_list[0].id;
					}
				}

			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
			});
		},

		async getQuestionItems() {

			this.form.recipient_id = 0;
			this.form.question_id  = 0

			let url = 'memorandum/departments/' + this.form.service_id  + '/questions';
			if(this.mem_addon.length > 0) {
				url = 'memorandum/departments/' + this.form.service_id  + '/' + this.mem_addon + '/questions';
			}

			this.$store.dispatch('memorandum_create/SET_CREATE_MEM_FIELDS', {
				'question_list': []
			});

			await api.get(url).then(({data}) => {
				if (data.status === "operation_success") {
					this.$store.dispatch('memorandum_create/SET_CREATE_MEM_FIELDS', {
						'question_list': data.data
					});

					if (this.question_list.length > 0 && this.question_list.length === 1) {
						  this.form.question_id = this.question_list[0].template_id
						  this.is_lock_question = true;
					}
					else {
						this.is_lock_question = false;
					}
				}
			}).catch(err => {
				EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
			});
		},

		async getRecipient() {
			this.form.recipient_id = 0;
			if(this.form.question_id > 0) {
				let url = 'memorandum/{organization_id}/{template_quest_id}/recipient';
				url = url.replace("{organization_id}", this.form.tov_id);
				url = url.replace("{template_quest_id}", this.form.question_id);

				await api.get(url).then(({data}) => {
					if (data.status === "operation_success") {
						this.recipient.rec_id  = data.data.recipient_id;
						this.recipient.user_id = data.data.user_id;
						this.form.recipient_id = data.data.recipient_id;

					} else {
						this.recipient.rec_id = 0;
						this.recipient.user_id = 0;
						this.form.recipient_id = 0;
					}
				}).catch(err => {
					this.recipient.rec_id = 0;
					this.recipient.user_id = 0;
					this.form.recipient_id = 0;

					EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
				});
			}
		},

		onSubmit() {
			let self = this;
			this.validate_memorandum_init().then(({data}) => {
				this.$store.dispatch('memorandum_create/SET_ACTIVE_MEMORANDUM', {form : self.form});
			}).catch(({response}) => {
				console.error(response);
				EventBus.$emit('show_err',{
					time : 10,
					err : response.data.message
				});
			});
		},

		async validate_memorandum_init() {

			let url = 'memorandum/{organization_id}/{template_quest_id}/validate_init';
			url = url.replace("{organization_id}", this.form.tov_id);
			url = url.replace("{template_quest_id}", this.form.question_id);

			return await api.get(url);
		},
	},

	watch : {
		'mem_addon' : function() {
			if (myapp_config.debugState)
				console.log("%c|___addon_change ", "color: #ffc241",this.form.addon);

			this.form.service_id = 0;
			this.getServicesItems();
		},

		'form.service_id': function () {
			if (myapp_config.debugState)
				console.log("%c|___selected_service ", "color: #ffc241",this.form.service_id);

			this.form.question_id = 0;

			if(parseInt(this.form.service_id) > 0) {
				this.getQuestionItems();
			} else {

				this.$store.dispatch('memorandum_create/SET_CREATE_MEM_FIELDS', {
					'question_list': []
				});
			}
		},

		'form.question_id': function () {
			if (myapp_config.debugState)
				console.log("%c|___selected_question ", "color: #ffc241",this.form.question_id);

			if(parseInt(this.form.tov_id) > 0) {
				this.getRecipient();
			}
		},

		'form.tov_id': function () {
			if(parseInt(this.form.question_id) > 0) {
				this.getRecipient();
			}
		}

	},


	computed : {
		...mapGetters({
			'mem_create': "memorandum_create/getMemCreateField",
			'user' : "user/getUser"
		}),

		current_step () {
			return this.mem_create('active_menu')
		},

		create_memorandum() {
			return this.mem_create('create_memorandum')
		},

		tov_list () {
			return this.create_memorandum.tov_list;
		},

		service_list() {
			return this.create_memorandum.service_list;
		},

		question_list() {
			return this.create_memorandum.question_list;
		},

		recipient() {
			return this.create_memorandum.recipient;
		},

		mem_addon () {
			return this.current_step.addon;
		},

		form () {
			return this.create_memorandum.form;
		},

		post_form() {
			return this.form;
		},

		validation_question() {
			return this.form.service_id > 0 && this.form.question_id >0;
		},

		validation_form() {
			if(this.form.tov_id > 0 && this.form.question_id > 0 && this.form.service_id > 0 && this.form.recipient_id > 0) {
				return false;
			}
			return true;
		},

		def_tov_id() {
			if(this.user.hasOwnProperty("org_def")) {
				return parseInt(this.user.org_def);
			}

			return 0;
		},

		def_service_id() {

			if(this.user.hasOwnProperty("service_def")) {
				return parseInt(this.user.service_def);
			}

			return 0;
		}
	}
}
</script>

<style scoped>
.empty_recipient {
	min-height:97px;
}

.slide-fade-enter-active {
	transition: all .1s ease;
}
.slide-fade-leave-active {
	transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
	/* .slide-fade-leave-active до версии 2.1.8 */ {
	transform: translateX(10px);
	opacity: 0;
}
</style>
